import { FormValidationSchema } from "@/components/Form/types";
import { I_ForgotPasswordPage } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";
import { EMAIL_PATTERN } from "./patterns";

export const forgotPasswordValidation = (data: I_ForgotPasswordPage): FormValidationSchema[] => [
  {
    name: "email",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("email", "required", data),
      },
      pattern: {
        value: EMAIL_PATTERN,
        message: getRuleErrorMessage("email", "pattern", data),
      },
    },
  },
];
